import React,  {useState, useEffect, useCallback} from 'react';
//import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useSelector,useDispatch } from "react-redux";
import { Minimal as MinimalLayout } from '../../layouts';
import { ErrorPage } from "../../views";
import { Typography, CircularProgress } from '@material-ui/core';
import { initializeApp } from '../../redux/reducers/appReducer';

import { initFitData } from '../../redux/reducers/scheduleAttendantReducer';

const useStyles = makeStyles(theme => ({
    init: {
        position: 'fixed',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        color: theme.palette.primary.main
        
    },
    progress: {
        margin: '10px'
    }
  }));

const ControlApp = ({ children }) => {
    const classes = useStyles();
    const { globalError, initialzed, isAuthenticated } = useSelector(state => state.appReducer);
    const { currentRoom } = useSelector(state => state.schAttenReducer);
    const dispatch = useDispatch();

    const stableDispatch = useCallback(args => {
        return dispatch(args)
      }, [dispatch]);

    useEffect(() => {
        stableDispatch(initializeApp());   
    }, [stableDispatch]);

    useEffect(() => {
        if (initialzed&&isAuthenticated) stableDispatch(initFitData());   
    }, [stableDispatch,initialzed,isAuthenticated]);

    // useEffect(() => {
    //     localStorage.setItem('currentRoom', currentRoom);
    // }, [currentRoom]);

    return (
    <>
    {globalError
        ?<MinimalLayout>
            <ErrorPage/>
        </MinimalLayout>
        :!initialzed
            ?<MinimalLayout>
                <div className={classes.init}>
                    <CircularProgress color="inherit" className={classes.progress} />
                    <Typography variant="subtitle2" noWrap color="inherit">
                        Инициализация...
                    </Typography>
                </div>
            </MinimalLayout>
            :children}
    </>
    );
};

ControlApp.propTypes = {
    children: PropTypes.any.isRequired,
};


export default ControlApp;
